export const ko = {
  common: {
    loading: '불러오는 중...',
    error: '오류가 발생했습니다',
    save: '저장',
    cancel: '취소',
    back: '뒤로',
  },
  tabs: {
    home: '홈',
    myLeaves: '내 근태',
    settings: '설정',
  },
  settings: {
    title: '설정',
    theme: '테마',
    themeLight: '라이트',
    themeDark: '다크',
    language: '언어',
    account: '계정',
    logout: '로그아웃',
  },
  push: {
    open: '열기',
  },
};
